import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraLink, SpecraSpinner, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { VehicleNoticeStatus } from '../../../../../../../gen/ts/mono/morgans/v1/morgans_pb';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { useVehicleNotices } from './hooks';
const dueDate = (row)=>row.responseDue?.toDate().toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
    });
export function noticeStatusText(row) {
    switch(row.status){
        case VehicleNoticeStatus.WATCHING:
            return 'watching';
        case VehicleNoticeStatus.DUE:
            {
                const date = dueDate(row);
                return date ? `due ${date}` : 'due';
            }
        default:
            return 'new';
    }
}
/** The pursuit when the tenant watches the notice, else the notice in the market desk. */ export const noticeHref = (row)=>row.pursuitOpportunityId ? `/opportunities?watchOpportunity=${encodeURIComponent(row.pursuitOpportunityId)}` : `/opportunities?notice=${encodeURIComponent(row.noticeId)}`;
export function VehicleNotices({ vehicleId }) {
    const query = useVehicleNotices(vehicleId);
    const quiet = (text, testId)=>/*#__PURE__*/ _jsx(SpecraText, {
            as: "p",
            size: "meta",
            tone: "muted",
            "data-testid": testId,
            children: text
        });
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": Testids.registryVehicle.noticesSection,
        children: query.isPending ? /*#__PURE__*/ _jsx(SpecraSpinner, {
            label: "Loading notices"
        }) : query.isError ? quiet('Notices could not be loaded.') : query.data.length === 0 ? quiet('No open notices on this vehicle.', Testids.registryVehicle.noticesEmpty) : /*#__PURE__*/ _jsx("ul", {
            className: "space-y-1",
            children: query.data.slice(0, 5).map((row)=>/*#__PURE__*/ _jsx("li", {
                    "data-testid": Testids.registryVehicle.noticeRow,
                    children: /*#__PURE__*/ _jsx(SpecraLink, {
                        href: noticeHref(row),
                        renderLink: renderRouterLink,
                        children: `${row.title} · ${noticeStatusText(row)}`
                    })
                }, row.noticeId))
        })
    });
}
